import CssBaseline from '@mui/material/CssBaseline'

const Baseline = () => {
  return <CssBaseline />
}

export default Baseline
